import axiosInstance from '../functions/axiosInstance';
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const getTargetResourceRatingDictionary = async (targetResources = null, apiToken = null,
    subject = {
        "reference": "Group/414027",
        "type": "Group",
        "display": "General Population (414027)"
    }) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!targetResources) {
        console.log("no targetResources");
        return null;
    }
    let subjectReference = subject?.reference || "Group/414027";
    console.log("CALLING SERVER with gettargetresourceratingdictionary")
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'gettargetresourceratingdictionary',
            'apiToken': apiToken,
            'targetResources': targetResources,
            'tool': 'SummaryOfFindingsAuthoringTool',
            'subjectReference': subjectReference
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
            //resp.data includes { "success": true,
            //  "targetResourceRatingDictionary": targetResourceRatingDictionary }
            // where targetResourceRatingDictionary uses foi as key and object with
            //    {
            //        "exists": false, "resource": "", "targettitle": targettitle,
            //         "targettitleTrimmed": targettitle.replace("OutcomeDefinition: ", ""),
            //        "resourceFOI": "", "resourcetitle": "", "desirabilityCode": "", "desirabilityDisplay": "",
            //        "quantityValue": 0, "fli": resource.fli
            //    }
        }
        console.log("NO RESPONSE from gettargetresourceratingdictionary call");
    }).catch((error) => { console.log(error); });
};

export default getTargetResourceRatingDictionary;